import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = (isFranchise = false, isSupplyChainManager = false) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Profile',
    value: 'bussinessPermitI',
  },
  // {
  //   label: 'Address',
  //   value: 'Addressnn',
  // },
  {
    label: 'Material Hub',
    value: 'materialHub',
  },
  /* {
    label: 'Birthday',
    value: 'birthday',
  },
  {
    label: 'Gender',
    value: 'gender',
  }, */
  /* {
    label: 'Email Address',
    value: 'email',
  }, */
  {
    label: 'Type',
    value: 'customerTypeWc',
  },
  {
    label: 'Date',
    value: 'WSDate',
  },
  // {
  //   label: 'ID Number',
  //   value: 'mobile',
  // },

  {
    label: 'Lifetime',
    value: 'totalDepositedQuantitynnn',
  },
  // {
  //   label: 'Sankey',
  //   value: 'sankey',
  // },
  // {
  //   label: 'Certificate',
  //   value: 'CertificateTry',
  // },
  {
    label: 'Rewards',
    value: 'couponRewards',
  },
  {
    label: 'Status',
    value: 'statusUm',
  },
  // {
  //   action: [
  //     'qr',
  //     ...((isSupplyChainManager && ['edit', 'delete']) || []),
  //     ...((isFranchise && ['edit', 'delete']) || []),
  //   ],
  // },



  {
    action: [
      '',
      ...((isSupplyChainManager && ['', '']) || []),
      ...((isFranchise && ['', '']) || []),
    ],
  },




  /*  {
    label: 'Joining Date',
    value: 'joinDate',
  },
  {
    label: 'Current Level',
    value: 'currentLevel',
  },
  {
    label: 'Points Earned',
    value: 'pointEarned',
  },
  {
    label: 'Redeemed',
    value: 'pointRedeemed',
  }, */
]

const roleColumns = (isFranchise = false, isSupplyChainManager = false) => {
  return columnGenerators(header(isFranchise, isSupplyChainManager))
}
export { roleColumns }
